import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4 18l2-2h14V4H4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
})), 'ChatBubbleTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChatBubbleTwoTone.js
// module id = 2748
// module chunks = 2